function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useMemo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Icon from '../../../icon/Icon';
import text from '../../../../text';
import { useContext } from 'react';
import { MapViewContext } from '../../../mapView/mapViewContext';
import _ from 'lodash/fp';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { clearBoundaries, showModal } from '../../../../redux/actions';
import { DELETE_SHAPES_MODAL } from '../../DeleteShapesModal';
export default function Footer() {
    var dispatch = useDispatch();
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var _state_productSelected = state.productSelected, data = _state_productSelected.data, productType = _state_productSelected.product;
    var product = data[1][0];
    var isAllSelectionsVisible = state.selections ? _.every([
        'visible',
        true
    ], _.filter([
        'category_name',
        productType
    ])(state.selections)) : false;
    var isAllSelectionsHidden = state.selections ? _.every([
        'visible',
        false
    ], _.filter([
        'category_name',
        productType
    ])(state.selections)) : false;
    var eyeIcon = useMemo(function() {
        return isAllSelectionsVisible ? 'eye' : isAllSelectionsHidden ? 'eye-slash' : 'eye-mixed-state';
    }, [
        isAllSelectionsVisible,
        isAllSelectionsHidden
    ]);
    var handleDelete = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var selectionsToDelete, childrenSelections;
            return _ts_generator(this, function(_state) {
                selectionsToDelete = state.selections.filter(function(selection) {
                    return selection.product_id === product.product_id;
                });
                childrenSelections = state.selections.filter(function(selection) {
                    return selectionsToDelete.some(function(selectionToDelete) {
                        return selectionToDelete.id === selection.parent_selection_id;
                    });
                });
                if (state.selections.length === selectionsToDelete.length) {
                    dispatch(clearBoundaries());
                }
                dispatch(showModal(DELETE_SHAPES_MODAL, {
                    selectionsToDelete: _to_consumable_array(selectionsToDelete).concat(_to_consumable_array(childrenSelections)),
                    associatedAddOns: childrenSelections
                }));
                actions.clearProductSelected();
                event.stopPropagation();
                return [
                    2
                ];
            });
        });
        return function handleDelete(event) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!state.isProductModalExpanded) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Modal.Footer, null, /*#__PURE__*/ React.createElement(Button, {
        style: {
            width: '72px'
        },
        variant: "light",
        className: "row-action with-text icon-button",
        onClick: function() {
            actions.toggleProductVisibility(isAllSelectionsVisible, product);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: classNames({
            original: !isAllSelectionsVisible
        }),
        icon: eyeIcon
    }), /*#__PURE__*/ React.createElement("span", null, isAllSelectionsVisible ? text('hide') : text('show'))), /*#__PURE__*/ React.createElement(Button, {
        variant: "light",
        className: "row-action with-text icon-button",
        onClick: handleDelete
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "trash"
    }), /*#__PURE__*/ React.createElement("span", null, text('delete'))));
}
